import { AnyAction } from 'redux';
import * as actionTypes from '../actions/app';

import isObject from 'lodash/isObject';

type TInitialState = {
  loaded: boolean;
  space: {
    loaded: boolean;
    current: any;
    history: any[];
  };
  state: {
    isCameraSyncEnabled: boolean;
    isStickEnabled: boolean;
    isContentVisible: boolean;
    coordsSelectEnabled: boolean;
    showLoader: boolean;
    lookAt: null | { x: number; y: number };
    spotLookAt: null | { x: number; y: number };
  };
};

const initialState: TInitialState = {
  loaded: false,
  state: {
    isCameraSyncEnabled: false,
    isStickEnabled: false,
    isContentVisible: true,
    coordsSelectEnabled: false,
    showLoader: false,
    lookAt: null,
    spotLookAt: null,
  },
  space: {
    loaded: false,
    current: {},
    history: [{}, {}],
  },
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case actionTypes.APP_UPDATE_STATE: {
      if (!isObject(action.payload)) {
        return state;
      }

      return {
        ...state,
        state: {
          ...state.state,
          ...action.payload,
        },
      };
    }

    case actionTypes.APP_SET_CURRENT_SPACE: {
      return {
        ...state,
        space: {
          ...state.space,
          current: action.payload,
        },
      };
    }

    case actionTypes.APP_SET_CURRENT_LOADED_SPACE: {
      return {
        ...state,
        space: {
          ...state.space,
          loaded: true,
          current: action.payload,
        },
      };
    }

    case actionTypes.APP_NAVIGATE_SPACE: {
      const currSpace: any = state.space.history[1];

      if (action.payload.id === currSpace.id) {
        return state;
      }

      const history = [currSpace, action.payload];

      return {
        ...state,
        space: {
          ...state.space,
          loaded: false,
          history,
        },
      };
    }

    default:
      return state;
  }
};
